import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-persona.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.persona',
    description: 'Bar chart of change impacts by persona',
    name: 'Change Impacts by Persona',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
